import styled from 'styled-components';

export const Container = styled.iframe({
  width: '100%',
  height: '80vh',
  borderWidth: 0,
});
